import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";
import BaseRootOption from "%/dynamic-component-editor/classes/base-root-option";

export default class ComponentName extends BaseRootOption {
  static userInterfaceComponent = {
    label: "Name",
    component: inspectorTools.SIMPLE_INPUT,
  };

  static defaultValue = "New component";

  static validations = [
    BaseRootOption.isRequired,
    value => {
      if (value.length > 24) {
        return "Name must be less than 24 characters long";
      }
    },
  ];
}
